import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import {
    Typography,
} from '@material-ui/core';

import { PageLayout } from '../../common/components';
import { getVideosForElement } from '../../common/videoUtil';
import { getBreadCrumb } from '../../common/breadcrumbUtil';
import { patientProgramElementGroups } from '../../common/constants';

const styles = theme => ({
    root: {
        marginTop: theme.spacing(4),
    },
    element: {
        marginBottom: theme.spacing(4),
    },
    elementHeading: {
        borderBottom: theme.youwell.borders.normal,
        borderBottomColor: theme.palette.secondary.main,
        borderBottomWidth: 4,
        display: 'flex',
        alignItems: 'center',
    },
    elementHeadingTitle: {
        flex: '1 1 auto',
    },
    videos: {
        display: 'flex',
    },
    video: {
        flex: '0 1 50%',
        padding: theme.spacing(2),
    },
    noVideos: {
        margin: theme.spacing(2),
    },
});


class Videos extends React.Component {
    render() {
        const {
            classes, translate, currentProgram, clientConfig,
        } = this.props;

        if (!currentProgram) {
            return null;
        }

        const mainElements = (currentProgram.groupedElements && currentProgram.groupedElements[patientProgramElementGroups.main]) || [];

        return (
            <PageLayout
                breadcrumb={getBreadCrumb(translate('videos.heading'), translate, clientConfig)}
            >
                <div className={classes.root}>
                    {mainElements.map(element => (
                        <div className={classes.element} key={element.module ? element.module.id : element.task && element.task.id}>

                            <div className={classes.elementHeading}>
                                <Typography variant="subtitle1" color="inherit" className={classes.elementHeadingTitle}>
                                    {element.name}
                                </Typography>
                            </div>

                            <div className={classes.videos}>
                                {getVideosForElement(element).map((video, cI) => (
                                // eslint-disable-next-line react/no-array-index-key
                                    <React.Fragment key={cI}>
                                        {video.html && (
                                        /* eslint-disable react/no-danger */
                                            <div dangerouslySetInnerHTML={{ __html: video.html }} className={classes.video} />
                                        /* eslint-enable react/no-danger */
                                        )}
                                        {video.Component && (
                                            <div className={classes.video}>
                                                {video.Component}
                                            </div>
                                        )}
                                        {video.none && (
                                            <Typography variant="subtitle2" color="textSecondary" className={classes.noVideos}>
                                                {translate('videos.noVideosForModule')}
                                            </Typography>
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </PageLayout>
        );
    }
}

Videos.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    clientConfig: PropTypes.object.isRequired,
    currentProgram: PropTypes.object,
};

Videos.defaultProps = {
    currentProgram: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    clientConfig: state.auth.clientConfig,
    currentProgram: state.programStore.currentProgram,
});


export default connect(mapStateToProps)(withStyles(styles)(Videos));
